<template>
  <path
    fill="currentColor"
    d="M21 4.5v9.75a1.5 1.5 0 0 1-1.5 1.5H9.31l.97.97a.75.75 0 1 1-1.06 1.06l-2.25-2.25a.749.749 0 0 1 0-1.06l2.25-2.25a.75.75 0 1 1 1.06 1.06l-.97.97H19.5V4.5H9v.75a.75.75 0 0 1-1.5 0V4.5A1.5 1.5 0 0 1 9 3h10.5A1.5 1.5 0 0 1 21 4.5ZM15.75 18a.75.75 0 0 0-.75.75v.75H4.5V9.75h10.19l-.97.97a.75.75 0 1 0 1.06 1.06l2.25-2.25a.748.748 0 0 0 0-1.06l-2.25-2.25a.75.75 0 1 0-1.06 1.06l.97.97H4.5A1.5 1.5 0 0 0 3 9.75v9.75A1.5 1.5 0 0 0 4.5 21H15a1.5 1.5 0 0 0 1.5-1.5v-.75a.75.75 0 0 0-.75-.75Z"
  />
</template>
